import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[asciiOnly]'
})
export class AsciiOnlyDirective {
  @Output() caracterInvalido = new EventEmitter<string>();

  private readonly ASCII_PATTERN = /^[\x00-\x7F]*$/;
  private readonly CARACTERES_INVALIDOS_COMUNS = {
    'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
    'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
    'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
    'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
    'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'ç': 'c', 'ñ': 'n',
    'Á': 'A', 'À': 'A', 'Ã': 'A', 'Â': 'A', 'Ä': 'A',
    'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
    'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
    'Ó': 'O', 'Ò': 'O', 'Õ': 'O', 'Ô': 'O', 'Ö': 'O',
    'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
    'Ç': 'C', 'Ñ': 'N'
  };

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const input = this.el.nativeElement;
    const valorOriginal = input.value;
    
    // Verificar se há caracteres não-ASCII
    if (!this.ASCII_PATTERN.test(valorOriginal)) {
      // Tentar substituir caracteres conhecidos
      let valorLimpo = this.substituirCaracteresEspeciais(valorOriginal);
      
      // Remover caracteres que não puderam ser substituídos
      valorLimpo = valorLimpo.replace(/[^\x00-\x7F]/g, '');
      
      // Atualizar o valor do input
      input.value = valorLimpo;
      
      // Disparar evento de input para atualizar o ngModel
      input.dispatchEvent(new Event('input'));
      
      // Emitir evento de caractere inválido
      const caracteresInvalidos = this.encontrarCaracteresInvalidos(valorOriginal);
      if (caracteresInvalidos.length > 0) {
        this.caracterInvalido.emit(caracteresInvalidos);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    
    const pastedText = event.clipboardData?.getData('text') || '';
    const textoLimpo = this.limparTexto(pastedText);
    
    // Inserir texto limpo
    const input = this.el.nativeElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const valorAtual = input.value;
    
    input.value = valorAtual.substring(0, start) + textoLimpo + valorAtual.substring(end);
    
    // Mover cursor
    const novaPosicao = start + textoLimpo.length;
    input.setSelectionRange(novaPosicao, novaPosicao);
    
    // Disparar evento de input
    input.dispatchEvent(new Event('input'));
    
    // Emitir aviso se houve caracteres inválidos
    if (pastedText !== textoLimpo) {
      const caracteresInvalidos = this.encontrarCaracteresInvalidos(pastedText);
      if (caracteresInvalidos.length > 0) {
        this.caracterInvalido.emit(caracteresInvalidos);
      }
    }
  }

  private substituirCaracteresEspeciais(texto: string): string {
    let resultado = texto;
    
    for (const [invalido, valido] of Object.entries(this.CARACTERES_INVALIDOS_COMUNS)) {
      resultado = resultado.split(invalido).join(valido);
    }
    
    return resultado;
  }

  private limparTexto(texto: string): string {
    let textoLimpo = this.substituirCaracteresEspeciais(texto);
    textoLimpo = textoLimpo.replace(/[^\x00-\x7F]/g, '');
    return textoLimpo;
  }

  private encontrarCaracteresInvalidos(texto: string): string {
    const caracteresUnicos = new Set<string>();
    
    for (const char of texto) {
      if (!this.ASCII_PATTERN.test(char)) {
        caracteresUnicos.add(char);
      }
    }
    
    return Array.from(caracteresUnicos).join(', ');
  }
}

